import { render, staticRenderFns } from "./edit-demo.vue?vue&type=template&id=143b728e&scoped=true&"
import script from "./edit-demo.vue?vue&type=script&lang=js&"
export * from "./edit-demo.vue?vue&type=script&lang=js&"
import style0 from "./edit-demo.vue?vue&type=style&index=0&id=143b728e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143b728e",
  null
  
)

export default component.exports